import React, { useCallback, useEffect, useState } from 'react';
import westImg from 'src/assets/img/westImg.png';
import fsImg from 'src/assets/img/fsImg.png';
import logImg from 'src/assets/img/logImg.png';
import lianiImg from 'src/assets/img/lianiImg.png';
import upDirectionAerrow from 'src/assets/svgs/upDirectionAerrow.svg';
import searchIcon from 'src/assets/svgs/searchIcon.svg';
import downDirectionAerrow from 'src/assets/svgs/downDirectionAerrow.svg';
import { useDeviceDetect } from 'src/hooks/useDeviceDetect';
import { TiFlash } from 'react-icons/ti';
import { FaCircleExclamation } from 'react-icons/fa6';
import { breakPoints } from 'src/constants/general';
import { BsDot } from 'react-icons/bs';
import { jobStatus } from 'src/constants/general';
import { convertedHoursMinutes, getRemovetzTime } from 'src/utils/function';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const ResponsiveTopRequestorEmployee = ({
    modalOpenTopResponsive,
    jobListData,
    openAcoordionResponsive,
    setOpenAcoordionResponsive,
    employeeListData,
    topRequestorId,
    getEmployList,
    getJobList,
    isJobList,
    setIsjobList,
    requestorName,
    employeeId,
    isEmployeeListLoading,
}: any) => {
    const { isMobile }: any = useDeviceDetect();
    const [ascending, setAscending] = useState(true);
    const [searchInput, setSearchInput] = useState('');
    const [selectedEmployee, setSelectedEmployee] = useState(employeeId);
    const GetStartDate = (row: any) => getRemovetzTime(row.startDate, 'MMM. DD, YY');

    const GetEndDate = (row: any) => {
        if (row.endDate) {
            return getRemovetzTime(row.endDate, 'MMM. DD, YY');
        } else {
            return (
                <div className="">
                    <p className="px-5">-</p>
                </div>
            );
        }
    };
    const Getstatus = (row: any) => {
        const statusColors: any = {
            [jobStatus.complete]: 'bg-Green20 text-Green80',
            [jobStatus.cancel]: 'bg-purpleLight text-purple80',
            [jobStatus.fail]: 'bg-red20 text-red500',
            [jobStatus.inprogress]: 'bg-yellow20 text-yellow80',
            [jobStatus.invoiced]: 'bg-secondary20 text-secondary',
        };

        const isColor = statusColors[row.status] || '';
        return (
            <div className={`h-6 pe-2 min-w-24 py-1 ${isColor} rounded-lg justify-center items-center inline-flex`}>
                <div>
                    <BsDot size={18} />
                </div>
                <div className={`text-xs font-medium`}>{row.status}</div>
            </div>
        );
    };

    const debounce = (func: any, delay: any) => {
        let timeoutId: any;
        return (...args: any) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func(...args), delay);
        };
    };
    const handleSearch = useCallback(
        debounce((searchTerm: any) => {
            getEmployList(topRequestorId, requestorName, searchTerm);
        }, 500),
        [],
    );
    const handleChange = (e: any) => {
        setSearchInput(e.target.value);
        handleSearch(e.target.value);
    };

    // Toggle sort between ASC and DESC for Job Hours
    const handleSort = () => {
        getJobList(topRequestorId, selectedEmployee, !ascending);
        setAscending(!ascending);
    };

    useEffect(() => {
        if (selectedEmployee) {
            getJobList(topRequestorId, selectedEmployee, ascending);
        }
    }, [selectedEmployee]);

    return isJobList ? (
        <>
            <div className=" w-full flex justify-between pb-4">
                <span>Employee Name: {selectedEmployee && employeeListData.find((item: any) => item.employeeId === selectedEmployee).full_name}</span>
                <button onClick={handleSort} className="flex items-center gap-2 border rounded-lg px-4 py-2 bg-white hover:bg-gray-200 font-medium">
                    <span>Sort by: Job Hours</span>
                    <span>{ascending ? '↑' : '↓'}</span>
                </button>
            </div>
            {jobListData?.length !== 0 &&
                jobListData?.map((data: any, index: number) => (
                    <div key={index} className={`${index === 0 ? '' : 'mt-3'}`}>
                        <div className={`w-full flex p-[10px] bg-white flex-col rounded-3xl ${openAcoordionResponsive === index ? '' : 'border-b-2 border-[#C1C1C1]'}`}>
                            <button className={`flex items-center justify-between w-full`} onClick={() => setOpenAcoordionResponsive((preavState: any) => (preavState === index ? null : index))}>
                                <div className="flex items-center gap-2">
                                    <img
                                        className="max-md:w-6 max-md:h-6 max-lg:w-[26px] max-lg:h-[26px] rounded-full"
                                        src={data.companyName === 'West' ? westImg : data.companyName === 'Log' ? logImg : data.companyName === 'Liani' ? lianiImg : fsImg}
                                        alt="img"
                                    />
                                    <div className="text-black max-md:text-xs font-bold font-['Satoshi Variable'] uppercase max-lg:text-sm">{data.companyName}</div>
                                </div>
                                <div className="flex items-center gap-2 ">
                                    {data.isAsap ? (
                                        <span className="w-5 h-5 rounded-full bg-red-50 text-red500 flex justify-center items-center">
                                            <TiFlash size={18} />
                                        </span>
                                    ) : (
                                        <span className="w-5 h-5 rounded-full flex justify-center items-center"></span>
                                    )}
                                    {data.isMandatory ? (
                                        <span className={`w-5 h-5 rounded-full bg-white text-blue-800 flex justify-center items-center`}>
                                            <FaCircleExclamation size={18} />
                                        </span>
                                    ) : (
                                        <span className="w-5 h-5 rounded-full flex justify-center items-center"></span>
                                    )}
                                </div>
                                <div className="max-md:flex flex-col font-['Satoshi Variable'] gap-1 max-lg:hidden">
                                    <div className="flex">
                                        <span className="text-[#627BE8] font-bold text-xs">Job Type :</span>
                                        <span className="font-medium text-xs ml-2">{data?.jobType}</span>
                                    </div>
                                    <div className="flex">
                                        <span className="text-[#627BE8] font-bold text-xs">Job ID :</span>
                                        <span className="font-medium text-xs ml-2">{data?.jobConfirmation}</span>
                                    </div>
                                </div>
                                <div className="max-lg:flex max-md:hidden">
                                    <span className="text-[#627BE8] font-bold text-xs">Job Type :</span>
                                    <span className="font-medium text-xs ml-2">{data?.jobType}</span>
                                </div>
                                <div className="max-lg:flex max-md:hidden">
                                    <span className="text-[#627BE8] font-bold text-xs">Job ID :</span>
                                    <span className="font-medium text-xs ml-2">{data?.jobConfirmation}</span>
                                </div>
                                <div>
                                    <span className={``}>
                                        <img className="w-[30px] h-[30px]" src={`${openAcoordionResponsive === index ? upDirectionAerrow : downDirectionAerrow}`} alt="img" />
                                    </span>
                                </div>
                            </button>
                            {isMobile < breakPoints.mobile ? (
                                <div className={`${openAcoordionResponsive === index ? 'block' : 'hidden'} mt-3 border-t-2 border-[#C1C1C1] p-[10px]`}>
                                    <div className="mb-2 flex items-center">
                                        <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">Requestor Name</span>
                                        <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                        <span className="font-['Satoshi Variable'] font-medium text-xs">{data?.requestorName}</span>
                                    </div>
                                    <div className="mb-2 flex items-center">
                                        <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">Location</span>
                                        <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                        <span className="font-['Satoshi Variable'] font-medium text-xs">{data?.location}</span>
                                    </div>
                                    <div className="mb-2 flex items-center">
                                        <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">Start Date</span>
                                        <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                        <span className="font-['Satoshi Variable'] font-medium text-xs">{GetStartDate(data)}</span>
                                    </div>
                                    <div className="mb-2 flex items-center">
                                        <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">End Date</span>
                                        <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                        <span className="font-['Satoshi Variable'] font-medium text-xs">{GetEndDate(data)}</span>
                                    </div>
                                    <div className="mb-2 flex items-center">
                                        <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">Department</span>
                                        <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                        <span className="font-['Satoshi Variable'] font-medium text-xs">{data?.departmentName}</span>
                                    </div>
                                    <div className="mb-2 flex items-center">
                                        <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">Job Hours</span>
                                        <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                        <span className="font-['Satoshi Variable'] font-medium text-xs">{convertedHoursMinutes(data?.totalHours, ':')}</span>
                                    </div>
                                    <div className="mb-2 flex items-center">
                                        <span className="w-[131px] font-['Satoshi Variable'] font-bold text-xs text-[#627BE8]">Status</span>
                                        <span className="mr-[10px] ml-[20px] text-[#627BE8]">:</span>
                                        <span className="font-['Satoshi Variable'] font-medium text-xs">{Getstatus(data)}</span>
                                    </div>
                                </div>
                            ) : (
                                <div className={`${openAcoordionResponsive === index ? 'block' : 'hidden'}`}>
                                    <div
                                        className={`${
                                            openAcoordionResponsive === index ? 'flex' : 'hidden'
                                        } mt-3 border-t-2 border-[#C1C1C1] pt-[10px] pb-[10px] pr-[15px] pl-[15px] justify-between items-center`}
                                    >
                                        <div className="">
                                            <div className="mb-4 flex items-center">
                                                <span className="w-[131px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">Requestor Name</span>
                                                <div className="flex items-center">
                                                    <span className="mx-[10px] text-[#627BE8]">:</span>
                                                    <span className="font-['Satoshi Variable'] font-medium text-sm">{data.requestorName}</span>
                                                </div>
                                            </div>
                                            <div className="mb-4 flex items-center">
                                                <span className="w-[131px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">Start Date</span>
                                                <div className="">
                                                    <span className="mx-[10px] text-[#627BE8]">:</span>
                                                    <span className="font-['Satoshi Variable'] font-medium text-sm">{GetStartDate(data)}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <div className="mb-4 flex items-center">
                                                <span className="w-[62px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">Location</span>
                                                <div className="">
                                                    <span className="mx-[10px] text-[#627BE8]">:</span>
                                                    <span className="font-['Satoshi Variable'] font-medium text-sm">{data?.location}</span>
                                                </div>
                                            </div>
                                            <div className="mb-4 flex items-center">
                                                <span className="w-[62px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">End Date</span>
                                                <div className="flex items-center">
                                                    <span className="mx-[10px] text-[#627BE8]">:</span>
                                                    <span className="font-['Satoshi Variable'] font-medium text-sm">{GetEndDate(data)}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <div className="mb-4 flex items-center">
                                                <span className="w-[82px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">Department</span>
                                                <div className="">
                                                    <span className="mx-[10px] text-[#627BE8]">:</span>
                                                    <span className="font-['Satoshi Variable'] font-medium text-sm">{data?.departmentName}</span>
                                                </div>
                                            </div>
                                            <div className="mb-4 flex items-center">
                                                <span className="w-[82px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">Status</span>
                                                <div className="flex items-center">
                                                    <span className="mx-[10px] text-[#627BE8]">:</span>
                                                    <span className="font-['Satoshi Variable'] font-medium text-sm">{Getstatus(data)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-4 flex items-center  pl-[15px] a ">
                                        <span className="w-[131px] font-['Satoshi Variable'] font-bold text-sm text-[#627BE8]">Job Hours</span>
                                        <div className="">
                                            <span className="mx-[10px] text-[#627BE8]">:</span>
                                            <span className="font-['Satoshi Variable'] font-medium text-sm">{convertedHoursMinutes(data?.totalHours, ':')}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
        </>
    ) : (
        <div className="pt-16 w-full">
            <div className="text-center text-zinc-800 text-lg font-medium font-['Satoshi Variable'] flex justify-between pb-4">
                <span>Requestor Name: {requestorName}</span>
                <div>
                    <div className="w-[300px] relative">
                        <input
                            className={`w-full h-8 px-5 py-1 pr-5 bg-white focus-visible:outline-none focus:border focus:border-primary rounded-3xl border border-gray40 placeholder:text-gray50`}
                            placeholder="Search"
                            value={searchInput}
                            onChange={handleChange}
                        />

                        <img className="w-5 h-5 absolute right-3 top-2" src={searchIcon} alt="searchicon" />
                    </div>
                </div>
            </div>
            <div className={`${modalOpenTopResponsive === 'Top Requestor' ? 'h-[calc(100vh-150px)]' : ''} scrollbar-hide overflow-y-auto `}>
                <div className="w-full">
                    <DataTable
                        value={employeeListData}
                        emptyMessage="No Job Record Found"
                        onRowClick={(e) => {
                            employeeId = e.data.employeeId;
                            setSelectedEmployee(employeeId);
                            setIsjobList(true);
                        }}
                        loading={isEmployeeListLoading}
                        className=" hover:cursor-pointer bg-gray-300 "
                    >
                        <Column field="full_name" header="Employee Name" style={{ minWidth: '200px' }}></Column>
                        <Column field="total_hours" header="Total Hours" body={(row) => convertedHoursMinutes(row.total_hours, ':')} style={{ minWidth: '150px' }}></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    );
};
export default ResponsiveTopRequestorEmployee;
